import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { BrowserView, MobileView } from 'react-device-detect'
import { useTranslation } from 'react-multi-lang'
import { ParallaxProvider } from 'react-scroll-parallax'
import Chart, { CategoryScale } from "chart.js/auto"
import { Fade, Zoom } from 'react-awesome-reveal'
import '../../styles/Goal/Goal.css'
import goalEtude from '../../assets/images/goal/goal-etude.gif'
import goalParc from '../../assets/images/goal/goal-parc.gif'
import goalSante from '../../assets/images/goal/goal-sante.gif'
import goalHealth from '../../assets/images/goal/goal-health.gif'
import goalEducation from '../../assets/images/goal/goal-education.gif'
import goalHouse from '../../assets/images/goal/goal-house.gif'
import goalHumanitarian from '../../assets/images/goal/goal-humanitarian.gif'
import goalDevelopment from '../../assets/images/goal/goal-development.gif'
import { Col, Row } from 'react-bootstrap'

function Goal() {

    const { type } = useParams()
    const text = useTranslation()
    Chart.register(CategoryScale)

    useEffect(() => {

        autoscroll()

        // eslint-disable-next-line
    }, [type])

    function autoscroll() {

        if (type === 'santé') {
            window.scrollTo({ top: document.getElementById('goalHealth').offsetTop, behavior: 'instant' })
        } else if (type === 'éducation') {
            window.scrollTo({ top: document.getElementById('goalEducation').offsetTop, behavior: 'instant' })
        } else if (type === 'habitat-construction') {
            window.scrollTo({ top: document.getElementById('goalHouse').offsetTop, behavior: 'instant' })
        } else if (type === 'aide-humanitaire') {
            window.scrollTo({ top: document.getElementById('goalHumanitarian').offsetTop, behavior: 'instant' })
        } else if (type === 'développement-durable') {
            window.scrollTo({ top: document.getElementById('goalDevelopment').offsetTop, behavior: 'instant' })
        } else {
            window.scrollTo({ top: 0, behavior: 'instant' })
        }

    }

    return (

        <>
            <Helmet>
                <meta name="title" content="Nos objectifs - Vietnamensemble" />
                <meta name="description" content="Association Vietnamensemble, nos objectifs" />
                <meta property="og:title" content="Nos objectifs - Vietnamensemble" />
                <meta property="og:description" content="Association Vietnamensemble, nos objectifs" />
                <meta property="og:url" content="https://www.vietnamensemble.org/objectifs" />
                <link rel="canonical" href="https://www.vietnamensemble.org/objectifs" />
            </Helmet>

            <BrowserView>
                <ParallaxProvider>
                    <div className='goal'>
                        <div id='goalTitle'>{text('goal.title1')}</div>
                        <Row className='goalSectionLight'>
                            <Col>
                                <Fade>
                                    <div className='goalSubTitle'>
                                        <b>Solidarité en action :</b>
                                        <br /><br />
                                        <b>Santé</b>, <b>éducation</b>, <b>habitat</b>, <b>aide humanitaire</b> et <b>développement durable</b> pour<br />redonner espoir et dignité aux personnes défavorisées.
                                    </div>
                                </Fade>
                                <Fade>
                                    <div className='goalSubTitle'>
                                        <b>Social</b>
                                        <br /><br />
                                        Vietnam Ensemble (Về) souhaite apporter son aide pour satisfaire les premiers
                                        besoins de santé, d'éducation et d'habitat.
                                        <br />
                                        <img src={goalSante} width={'70%'} alt={"goalHealth"} />
                                    </div>
                                </Fade>
                                <Fade>
                                    <div className='goalSubTitle'>
                                        <b>Economie</b>
                                        <br /><br />
                                        Tout en améliorant les conditions de vie des enfants et des familles pauvres au
                                        Vietnam, elle essaye de donner aux plus démunis les moyens de continuer et
                                        de pérenniser ces nouvelles activités.
                                        <br />
                                        <img className='goalSubTitleImage' src={goalParc} width={'30%'} alt={"goalHealth"} />
                                    </div>
                                </Fade>
                                <Fade>
                                    <div className='goalSubTitle'>
                                        <b>Environnement</b>
                                        <br /><br />
                                        En s'inscrivant pleinement dans le concept du développement durable. Un
                                        développement qui répond aux besoins du présent sans compromettre la
                                        capacité des générations futures de répondre aux leurs.
                                        <br /><br />
                                        <img className='goalSubTitleImage' src={goalEtude} width={'30%'} alt={"goalHealth"} />
                                    </div>
                                </Fade>
                            </Col>
                        </Row>
                        <Row className='goalSectionDark' id='goalHealth'>
                            <div id='goalTitle'>La santé</div>
                            <Col sm={4}>
                                <Zoom duration={500}>
                                    <img src={goalHealth} width={'100%'} alt={"goalHealth"} />
                                </Zoom>
                            </Col>
                            <Col sm={8}>
                                <Fade>
                                    <div className='goalSectionText'>
                                        L’association propose plusieurs types d’aide dans le domaine de la santé pour les personnes démunies au Vietnam.
                                        <br /><br />
                                        <b>Couverture de santé :</b> L’association met en place un programme de couverture de santé
                                        destiné aux personnes les plus démunies. Pour un tarif annuel de 46 euros, chaque bénéficiaire pourra accéder
                                        à une prise en charge médicale complète pendant un an. Cette initiative vise à offrir un soutien essentiel en
                                        matière de santé et à garantir aux personnes vulnérables un accès aux soins de base.
                                        <br /><br />
                                        <b>Aides médicales :</b> Elle finance l’achat et la distribution de médicaments aux organismes locaux
                                        agréés, fournit une aide médicale individualisée pour des personnes vulnérables (comme les personnes âgées,
                                        les nouveau-nés et les enfants atteints de malformations), et offre un soutien alimentaire et financier aux
                                        structures de santé locales, comme les dispensaires et les maisons de retraite.
                                        <br /><br />
                                        <b>Aides alimentaires et médicales :</b> En complément des soins médicaux, des repas ou des colis
                                        alimentaires sont souvent distribués pour répondre aux besoins essentiels des bénéficiaires.
                                        Ce programme reflète l’engagement de l’association à garantir un accès aux soins et à améliorer les conditions
                                        de vie des plus démunis.
                                    </div>
                                </Fade>
                            </Col>
                        </Row>
                        <Row className='goalSectionLight' id='goalEducation'>
                            <div id='goalTitle'>L'éducation</div>
                            <Col sm={8}>
                                <Fade>
                                    <div className='goalSectionText'>
                                        L’association développe plusieurs initiatives pour soutenir l’éducation des enfants défavorisés.
                                        <br /><br />
                                        <b>Aide aux étudiants :</b> L’association propose des aides à la scolarisation et soutiens les
                                        enfants pauvres dans les régions de Kiên Giang et Kontum, avec un suivi possible des familles. Chaque année,
                                        plusieurs dizaines à centaines d’enfants bénéficient de ce soutien, incluant des visites et des aides spécifiques
                                        pour leurs familles.
                                        <br /><br />
                                        <b>Soutiens scolaires :</b> Des enveloppes globales seront accordées pour le soutiens scolaire des étudiants.
                                        <br /><br />
                                        <b>Classe du cœur :</b> L’association apporte un soutien financier aux orphelinats, écoles et
                                        maisons des sœurs. Ce soutien couvre les fournitures scolaires, les rénovations de classes (notamment à
                                        Kontum) et les équipements essentiels à la vie scolaire des enfants (lits, chambres, vélos, etc.).
                                        Ce programme vise à améliorer les conditions de vie et de scolarité des enfants démunis, en leur offrant un
                                        accès à l’éducation et un environnement propice aux études.
                                    </div>
                                </Fade>
                            </Col>
                            <Col sm={4}>
                                <Zoom duration={500}>
                                    <img src={goalEducation} width={'100%'} alt={"goalHealth"} />
                                </Zoom>
                            </Col>
                        </Row>
                        <Row className='goalSectionDark' id='goalHouse'>
                            <div id='goalTitle'>Habitat et constructions</div>
                            <Col sm={4}>
                                <Zoom duration={500}>
                                    <img src={goalHouse} className='goalHouseImage' width={'80%'} alt={"goalHealth"} />
                                </Zoom>
                            </Col>
                            <Col sm={8}>
                                <Fade>
                                    <div className='goalSectionText'>
                                        L’association humanitaire met en œuvre divers projets pour améliorer les conditions de vie des
                                        populations démunies dans le domaine de l’habitat et des constructions.
                                        <br /><br />
                                        <b>Maison du cœur :</b> L’association finance la construction et la rénovation de maisons
                                        simples pour les familles les plus démunies à Kiên Giang, avec un coût estimé entre 1000 € et 1600 €
                                        par maison. Des travaux de rénovation pour des maisons délabrées peuvent également être réalisés
                                        pour quelques centaines d’euros.
                                        <br /><br />
                                        <b>Nouvelles classes scolaires et écoles :</b> L’association soutient la construction de
                                        nouvelles classes et d’écoles, en particulier pour les minorités ethniques, afin qu’elles puissent
                                        apprendre à lire, écrire et compter.
                                        <br /><br />
                                        <b>Accès à l’eau potable :</b> L’association finance la rénovation ou la création de puits pour
                                        garantir l’accès à l’eau potable pour les plus démunis. Elle met également en place des systèmes de
                                        filtres pour améliorer la qualité de l’eau.
                                        <br /><br />
                                        <b>Réparations, entretien de l’existant :</b> Des travaux de réparation et d’entretien sont
                                        réalisés sur les bâtiments existants, notamment la peinture, la rénovation des cuisines, salles de bain,
                                        toilettes, et des toitures.
                                        Ces projets visent à améliorer les conditions de vie en offrant des logements décents, en facilitant
                                        l’accès à l’éducation et à l’eau potable, et en maintenant des infrastructures en bon état pour les
                                        populations vulnérables.
                                    </div>
                                </Fade>
                            </Col>
                        </Row>
                        <Row className='goalSectionLight' id='goalHumanitarian'>
                            <div id='goalTitle'>L'aide humanitaire</div>
                            <Col sm={8}>
                                <Fade>
                                    <div className='goalSectionText'>
                                        L’association mène diverses actions dans le domaine humanitaire pour apporter une aide concrète
                                        aux populations les plus vulnérables.
                                        <br /><br />
                                        <b>Distribution de repas gratuits :</b> Chaque année, plusieurs centaines de repas gratuits
                                        sont distribués aux personnes en situation de précarité.
                                        <br /><br />
                                        <b>Dons et aides pour les populations démunies :</b> L’association organise des
                                        événements tels que des marchés solidaires pour fournir des aliments et des vêtements. Elle lance
                                        également des appels aux dons via des plateformes comme Leetchi pour financer des actions
                                        humanitaires locales à Kiên Giang et Kon Tum, ainsi que pour répondre aux urgences liées aux
                                        catastrophes naturelles, crises économiques ou sanitaires.
                                        <br /><br />
                                        <b>Aide et colis alimentaires :</b> Plusieurs tonnes de riz et de colis alimentaires sont
                                        distribuées chaque année, apportant un soutien essentiel aux familles dans le besoin.
                                        <br /><br />
                                        <b>Soutien aux orphelinats, pensionnats, maisons de retraite, écoles et villages :</b>
                                        L’association effectue des visites et distribue des cadeaux (jouets, peluches), des repas pour Noël et
                                        les fêtes locales, ainsi que des dons matériels tels que lits, vélos et couvertures pour améliorer les
                                        conditions de vie des plus vulnérables.
                                        Ces actions illustrent l’engagement de l’association à soutenir concrètement les populations en
                                        difficulté, en offrant de l’aide alimentaire, des dons matériels et des moments de réconfort.
                                    </div>
                                </Fade>
                            </Col>
                            <Col sm={4}>
                                <Zoom duration={500}>
                                    <img src={goalHumanitarian} width={'80%'} alt={"goalHealth"} />
                                </Zoom>
                            </Col>
                        </Row>
                        <Row className='goalSectionDark' id='goalDevelopment'>
                            <div id='goalTitle'>Développement durable</div>
                            <Col sm={4}>
                                <Zoom duration={500}>
                                    <img src={goalDevelopment} className='goalHouseImage' width={'80%'} alt={"goalHealth"} />
                                </Zoom>
                            </Col>
                            <Col sm={8}>
                                <Fade>
                                    <div className='goalSectionText'>
                                        L’association soutient diverses initiatives visant à promouvoir un développement durable et
                                        respectueux de l’environnement, tout en améliorant les conditions de vie des communautés locales.
                                        <br /><br />
                                        <b>Élevage :</b> Des programmes locaux d’élevage biologique de poules et de vaches sont
                                        mis en place pour favoriser une production alimentaire durable et locale.
                                        <br /><br />
                                        <b>Cultures :</b> L’association soutient des projets agricoles biologiques pour la culture de
                                        café, de légumes, de caoutchouc, d’arbres fruitiers et de poivre, contribuant ainsi à la diversité
                                        agricole et à la durabilité environnementale.
                                        <br /><br />
                                        <b>Encouragement des initiatives locales de développement durable :</b> L’association
                                        finance et soutient toutes les initiatives locales qui favorisent le développement durable. Elle aide les
                                        familles démunies à développer des moyens de subsistance économiques durables, leur permettant
                                        ainsi de subvenir à leurs besoins tout en respectant et préservant leur environnement.
                                        <br /><br />
                                        Ces actions visent à renforcer l’autonomie économique des populations locales, tout en préservant
                                        les ressources naturelles et en promouvant des pratiques agricoles et d’élevage respectueuses de
                                        l’environnement.
                                    </div>
                                </Fade>
                            </Col>
                        </Row>
                    </div>
                </ParallaxProvider>
            </BrowserView>

            <MobileView>
                <ParallaxProvider>
                    <div className='goal'>
                        <div id='goalTitle'>{text('goal.title1')}</div>
                        <Row className='goalSectionLightMobile'>
                            <Col>
                                <Fade>
                                    <div className='goalSubTitleMobile'>
                                        <b>Solidarité en action :</b>
                                        <br /><br />
                                        <b>Santé</b>, <b>éducation</b>, <b>habitat</b>, <b>aide humanitaire</b> et <b>développement durable</b> pour<br />redonner espoir et dignité aux personnes défavorisées.
                                    </div>
                                </Fade>
                                <Fade>
                                    <div className='goalSubTitleMobile'>
                                        <b>Social</b>
                                        <br /><br />
                                        Vietnam Ensemble (Về) souhaite apporter son aide pour satisfaire les premiers
                                        besoins de santé, d'éducation et d'habitat.
                                        <br />
                                        <img src={goalSante} width={'70%'} alt={"goalHealth"} />
                                    </div>
                                </Fade>
                                <Fade>
                                    <div className='goalSubTitleMobile'>
                                        <b>Economie</b>
                                        <br /><br />
                                        Tout en améliorant les conditions de vie des enfants et des familles pauvres au
                                        Vietnam, elle essaye de donner aux plus démunis les moyens de continuer et
                                        de pérenniser ces nouvelles activités.
                                        <br /><br />
                                        <img className='goalSubTitleImage' src={goalParc} width={'30%'} alt={"goalHealth"} />
                                    </div>
                                </Fade>
                                <Fade>
                                    <div className='goalSubTitleMobile'>
                                        <b>Environnement</b>
                                        <br /><br />
                                        En s'inscrivant pleinement dans le concept du développement durable. Un
                                        développement qui répond aux besoins du présent sans compromettre la
                                        capacité des générations futures de répondre aux leurs.
                                        <br /><br />
                                        <img className='goalSubTitleImage' src={goalEtude} width={'30%'} alt={"goalHealth"} />
                                    </div>
                                </Fade>
                            </Col>
                        </Row>
                        <div className='goalSectionDarkMobile' id='goalHealth'>
                            <div id='goalTitle'>La santé</div>
                            <Zoom duration={500}>
                                <img src={goalHealth} className='goalHouseImageMobile' width={'100%'} alt={"goalHealth"} />
                            </Zoom>
                            <Fade>
                                <div className='goalSectionText'>
                                    L’association propose plusieurs types d’aide dans le domaine de la santé pour les personnes démunies au Vietnam.
                                    <br /><br />
                                    <b>Couverture de santé :</b> L’association met en place un programme de couverture de santé
                                    destiné aux personnes les plus démunies. Pour un tarif annuel de 46 euros, chaque bénéficiaire pourra accéder
                                    à une prise en charge médicale complète pendant un an. Cette initiative vise à offrir un soutien essentiel en
                                    matière de santé et à garantir aux personnes vulnérables un accès aux soins de base.
                                    <br /><br />
                                    <b>Aides médicales :</b> Elle finance l’achat et la distribution de médicaments aux organismes locaux
                                    agréés, fournit une aide médicale individualisée pour des personnes vulnérables (comme les personnes âgées,
                                    les nouveau-nés et les enfants atteints de malformations), et offre un soutien alimentaire et financier aux
                                    structures de santé locales, comme les dispensaires et les maisons de retraite.
                                    <br /><br />
                                    <b>Aides alimentaires et médicales :</b> En complément des soins médicaux, des repas ou des colis
                                    alimentaires sont souvent distribués pour répondre aux besoins essentiels des bénéficiaires.
                                    Ce programme reflète l’engagement de l’association à garantir un accès aux soins et à améliorer les conditions
                                    de vie des plus démunis.
                                </div>
                            </Fade>
                        </div>
                    </div>
                    <div className='goalSectionLightMobile' id='goalEducation'>
                        <div id='goalTitle'>L'éducation</div>
                        <Zoom duration={500}>
                            <img src={goalEducation} className='goalHouseImageMobile' width={'100%'} alt={"goalHealth"} />
                        </Zoom>
                        <Fade>
                            <div className='goalSectionText'>
                                L’association développe plusieurs initiatives pour soutenir l’éducation des enfants défavorisés.
                                <br /><br />
                                <b>Aide aux étudiants :</b> L’association propose des aides à la scolarisation et soutiens les
                                enfants pauvres dans les régions de Kiên Giang et Kontum, avec un suivi possible des familles. Chaque année,
                                plusieurs dizaines à centaines d’enfants bénéficient de ce soutien, incluant des visites et des aides spécifiques
                                pour leurs familles.
                                <br /><br />
                                <b>Soutiens scolaires :</b> Des enveloppes globales seront accordées pour le soutiens scolaire des étudiants.
                                <br /><br />
                                <b>Classe du cœur :</b> L’association apporte un soutien financier aux orphelinats, écoles et
                                maisons des sœurs. Ce soutien couvre les fournitures scolaires, les rénovations de classes (notamment à
                                Kontum) et les équipements essentiels à la vie scolaire des enfants (lits, chambres, vélos, etc.).
                                Ce programme vise à améliorer les conditions de vie et de scolarité des enfants démunis, en leur offrant un
                                accès à l’éducation et un environnement propice aux études.
                            </div>
                        </Fade>
                    </div>
                    <div className='goalSectionDarkMobile' id='goalHouse'>
                        <div id='goalTitle'>Habitat et constructions</div>
                        <Zoom duration={500}>
                            <img src={goalHouse} className='goalHouseImageMobile' width={'80%'} alt={"goalHealth"} />
                        </Zoom>
                        <Fade>
                            <div className='goalSectionText'>
                                L’association humanitaire met en œuvre divers projets pour améliorer les conditions de vie des
                                populations démunies dans le domaine de l’habitat et des constructions.
                                <br /><br />
                                <b>Maison du cœur :</b> L’association finance la construction et la rénovation de maisons
                                simples pour les familles les plus démunies à Kiên Giang, avec un coût estimé entre 1000 € et 1600 €
                                par maison. Des travaux de rénovation pour des maisons délabrées peuvent également être réalisés
                                pour quelques centaines d’euros.
                                <br /><br />
                                <b>Nouvelles classes scolaires et écoles :</b> L’association soutient la construction de
                                nouvelles classes et d’écoles, en particulier pour les minorités ethniques, afin qu’elles puissent
                                apprendre à lire, écrire et compter.
                                <br /><br />
                                <b>Accès à l’eau potable :</b> L’association finance la rénovation ou la création de puits pour
                                garantir l’accès à l’eau potable pour les plus démunis. Elle met également en place des systèmes de
                                filtres pour améliorer la qualité de l’eau.
                                <br /><br />
                                <b>Réparations, entretien de l’existant :</b> Des travaux de réparation et d’entretien sont
                                réalisés sur les bâtiments existants, notamment la peinture, la rénovation des cuisines, salles de bain,
                                toilettes, et des toitures.
                                Ces projets visent à améliorer les conditions de vie en offrant des logements décents, en facilitant
                                l’accès à l’éducation et à l’eau potable, et en maintenant des infrastructures en bon état pour les
                                populations vulnérables.
                            </div>
                        </Fade>
                    </div>
                    <div className='goalSectionLightMobile' id='goalHumanitarian'>
                        <div id='goalTitle'>L'aide humanitaire</div>
                        <Zoom duration={500}>
                            <img src={goalHumanitarian} width={'80%'} alt={"goalHealth"} />
                        </Zoom>
                        <Fade>
                            <div className='goalSectionText'>
                                L’association mène diverses actions dans le domaine humanitaire pour apporter une aide concrète
                                aux populations les plus vulnérables.
                                <br /><br />
                                <b>Distribution de repas gratuits :</b> Chaque année, plusieurs centaines de repas gratuits
                                sont distribués aux personnes en situation de précarité.
                                <br /><br />
                                <b>Dons et aides pour les populations démunies :</b> L’association organise des
                                événements tels que des marchés solidaires pour fournir des aliments et des vêtements. Elle lance
                                également des appels aux dons via des plateformes comme Leetchi pour financer des actions
                                humanitaires locales à Kiên Giang et Kon Tum, ainsi que pour répondre aux urgences liées aux
                                catastrophes naturelles, crises économiques ou sanitaires.
                                <br /><br />
                                <b>Aide et colis alimentaires :</b> Plusieurs tonnes de riz et de colis alimentaires sont
                                distribuées chaque année, apportant un soutien essentiel aux familles dans le besoin.
                                <br /><br />
                                <b>Soutien aux orphelinats, pensionnats, maisons de retraite, écoles et villages :</b>
                                L’association effectue des visites et distribue des cadeaux (jouets, peluches), des repas pour Noël et
                                les fêtes locales, ainsi que des dons matériels tels que lits, vélos et couvertures pour améliorer les
                                conditions de vie des plus vulnérables.
                                Ces actions illustrent l’engagement de l’association à soutenir concrètement les populations en
                                difficulté, en offrant de l’aide alimentaire, des dons matériels et des moments de réconfort.
                            </div>
                        </Fade>
                    </div>
                    <div className='goalSectionDarkMobile' id='goalDevelopment'>
                        <div id='goalTitle'>Développement durable</div>
                        <Zoom duration={500}>
                            <img src={goalDevelopment} className='goalHouseImageMobile' width={'80%'} alt={"goalHealth"} />
                        </Zoom>
                        <Fade>
                            <div className='goalSectionText'>
                                L’association soutient diverses initiatives visant à promouvoir un développement durable et
                                respectueux de l’environnement, tout en améliorant les conditions de vie des communautés locales.
                                <br /><br />
                                <b>Élevage :</b> Des programmes locaux d’élevage biologique de poules et de vaches sont
                                mis en place pour favoriser une production alimentaire durable et locale.
                                <br /><br />
                                <b>Cultures :</b> L’association soutient des projets agricoles biologiques pour la culture de
                                café, de légumes, de caoutchouc, d’arbres fruitiers et de poivre, contribuant ainsi à la diversité
                                agricole et à la durabilité environnementale.
                                <br /><br />
                                <b>Encouragement des initiatives locales de développement durable :</b> L’association
                                finance et soutient toutes les initiatives locales qui favorisent le développement durable. Elle aide les
                                familles démunies à développer des moyens de subsistance économiques durables, leur permettant
                                ainsi de subvenir à leurs besoins tout en respectant et préservant leur environnement.
                                <br /><br />
                                Ces actions visent à renforcer l’autonomie économique des populations locales, tout en préservant
                                les ressources naturelles et en promouvant des pratiques agricoles et d’élevage respectueuses de
                                l’environnement.
                            </div>
                        </Fade>
                    </div>
                </ParallaxProvider>
            </MobileView>

        </>

    )

}

export default Goal
